import { render, staticRenderFns } from "./detilIndre.vue?vue&type=template&id=672c51dd&scoped=true&"
import script from "./detilIndre.vue?vue&type=script&lang=js&"
export * from "./detilIndre.vue?vue&type=script&lang=js&"
import style0 from "./detilIndre.vue?vue&type=style&index=0&id=672c51dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c51dd",
  null
  
)

export default component.exports